import React, { useState } from 'react'

import ChromeIcon from 'Assets/images/chrome_icon.ico'
import './index.scss'
import { brandVars } from 'Utils/brandVars'

const WebPushPreview = ({ data }) => {
  const { url, title, image, body, actions, logo, link } = data
  const vars = brandVars()
  return (
    <div className="window-preview">
      <img alt="brand-logo" className="image" src={image || vars.logo}></img>

      <div className="content-wrapper">
        <img alt="browser-logo" className="logo" src={logo || ChromeIcon}></img>

        <div className="content">
          <p className="title common-ellipsis">{title}</p>
          <p className="description common-ellipsis">{body}</p>
          <p className="subtitle common-ellipsis">{link || vars.url}</p>
        </div>
      </div>
      {actions?.length ? (
        <div className="action-buttons-wrapper">
          {actions?.map((action) => (
            <div key={action.id} className="action-button">
              {action.title}
            </div>
          ))}
        </div>
      ) : null}
    </div>
  )
}

export default WebPushPreview
